module.exports = __webpack_public_path__ + "media/loose+ohoh.e6460f02.mp3";